import './index.css';
import { jsx } from 'react/jsx-runtime';
import { s as styles } from './bottom-sheet-3gMjDLi3.js';

const BottomSheetFooter = ({ children }) => (jsx("div", { className: styles.footerWithPadding, children: children }));

export { BottomSheetFooter };
//# sourceMappingURL=BottomSheetFooter.js.map
